<template>
<b-card>
  <b-row>
    <b-col sm="6" lg="3" v-for="nextItem in items" :key="nextItem.id">
      <lock-card :nextItem=nextItem></lock-card>
    </b-col>
  </b-row>
</b-card>
</template>

<script>
import LockCard from '@/views/base/haus/LockCard'
let qs = require('qs')
const constants = require('./shared/constants')
const BASE = constants.NEWPORT_CONST.API_URL
const API = BASE + '/api/locks/listUnassigned'
const API_ASSIGN_LOCK_TO_LOCATION = BASE + '/api/locks/assignLocation'

function postdata (url, data) {
  return fetch(url, {
    body: qs.stringify(data),
    headers: {
      'content-type': 'application/x-www-form-urlencoded',
      'accessToken': data.accessToken,
      'authorization': data.accessToken
    },
    method: 'POST'
  }).then(res => res.json())
}

async function getData () {
  let param = {
    client_id: constants.NEWPORT_CONST.CLIENT_ID,
    client_secret: constants.NEWPORT_CONST.CLIENT_SECRET,
    accessToken: localStorage.getItem('token')
  }
  let res = await postdata(API, param)
  if (res) {
    return res.locks
  }
}

export default {
  name: 'locks-unassigned',
  components: {
    LockCard
  },
  props: {
    caption: {
      type: String,
      default: 'Locks List'
    }
  },
  data: () => {
    return {
      locations: [],
      items: [],
      fields: [{
        key: 'check'
      },
      {
        key: 'lockId'
      },
      {
        key: 'lockAlias'
      },
      {
        key: 'lockName'
      },
      {
        key: 'lockMac'
      },
      {
        key: 'action'
      },
      {
        key: 'locationId'
      },
      {
        key: 'location'
      }
      ],
      currentPage: 1,
      perPage: 25,
      totalRows: 0,
      filter: null,
      selected: [],
      selectAll: false
    }
  },
  mounted () {
    getData().then(response => {
      this.$data.items = response
    })
  },
  methods: {
    getRowCount (items) {
      return items.length
    },
    openlink (link) {
      location.href = link
    },
    assignToLocation (lockId, idx) {
      let parameters = {
        client_id: constants.NEWPORT_CONST.CLIENT_ID,
        client_secret: constants.NEWPORT_CONST.CLIENT_SECRET,
        accessToken: localStorage.getItem('token'),
        lockId: lockId,
        locationId: localStorage.getItem('locationId')
      }
      postdata(API_ASSIGN_LOCK_TO_LOCATION, parameters)
        .then(data => {
          console.log(data)
        })
        .catch(error => {
          console.error(error)
        })
      this.$data.items.splice(idx, 1)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/base/LocksUnassigned.vue